import { lazy } from 'react';

export const DeveloperDetailsPage = lazy(() =>
  import('./ui/DeveloperDetailsPage').then((module) => ({
    default: module.DeveloperDetailsPage,
  }))
);
